const endedStatuses = new Set(["퇴원", "졸업"]);

export function compareStudentListOrder(first, second) {
  const group = Number(endedStatuses.has(first.status)) -
    Number(endedStatuses.has(second.status));
  return group || first.name.localeCompare(second.name, "ko");
}
